<nz-skeleton *ngIf="loading" [nzActive]="true"></nz-skeleton>

<ng-container *ngIf="!loading">
  <nz-empty
    *ngIf="!timeline"
    [nzNotFoundContent]="'ADMIN_DASHBOARD.CONTRACT_TIMELINE.NO_DATA' | translate">
  </nz-empty>

  <nz-alert
    *ngIf="isFreePlan"
    nzType="info"
    nzShowIcon
    [nzMessage]="'ADMIN_DASHBOARD.CONTRACT_TIMELINE.FREE_PLAN' | translate">
  </nz-alert>

  <ng-container *ngIf="timeline && !isFreePlan">
    <div class="timeline-summary">
      <nz-card class="summary-card">
        <div class="summary-card__label">{{ 'ADMIN_DASHBOARD.CONTRACT_TIMELINE.TITLE' | translate }}</div>
        <div class="summary-card__value">
          {{ timeline.currentPeriod?.start ? (formatDate(timeline.currentPeriod?.start) + ' - ' + formatDate(timeline.currentPeriod?.endInclusive)) : ('ADMIN_DASHBOARD.CONTRACT_TIMELINE.MISSING_CONTRACT_DATA' | translate) }}
        </div>
      </nz-card>
      <nz-card class="summary-card">
        <div class="summary-card__label">{{ 'ADMIN_DASHBOARD.TABLE.NEXT_MILESTONE' | translate }}</div>
        <div class="summary-card__value">
          {{ nextMilestoneSummary }}
        </div>
      </nz-card>
    </div>

    <nz-alert
      *ngIf="!timeline.currentPeriod"
      nzType="warning"
      nzShowIcon
      [nzMessage]="'ADMIN_DASHBOARD.CONTRACT_TIMELINE.MISSING_CONTRACT_DATA' | translate">
    </nz-alert>

    <ng-container *ngFor="let group of groupedMilestones">
      <nz-card class="timeline-group-card">
        <div class="timeline-group-card__head">
          <h4>{{ groupTitle(group.groupId) }}</h4>
          <span>{{ group.items.length }}</span>
        </div>

        <nz-list nzBordered>
          <nz-list-item *ngFor="let item of group.items" class="timeline-item">
            <div class="timeline-item__body">
              <div class="timeline-item__topline">
                <strong>{{ item.labelKey | translate }}</strong>
                <nz-tag [nzColor]="statusColor(item.status)">{{ statusLabel(item.status) }}</nz-tag>
              </div>
              <div class="timeline-item__meta">
                <span>{{ formatDate(item.date) }}</span>
                <span *ngIf="item.endDate">{{ formatDate(item.endDate) }}</span>
              </div>
              <div class="timeline-item__description" *ngIf="item.descriptionKey">
                {{ milestoneText(item) }}
              </div>
            </div>
          </nz-list-item>
        </nz-list>
      </nz-card>
    </ng-container>
  </ng-container>
</ng-container>
